/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { FieldMaker } from '@src/app/shared/field/FieldMaker';
import { FormConfig } from '@src/app/shared/form/FormConfig';
import { FieldSet, LAYOUT_OPTIONS } from '@src/app/shared/form/field-set/field-set.component';
import { FormNumberComponent } from '@src/app/shared/form/form-number/form-number.component';
import { FormPageComponent } from '@src/app/shared/form/form-page/form-page.component';
import { FormDateComponent } from '@src/app/shared/form/form-date/form-date.component';
import { Field } from '@src/app/shared/field/Field';
import { CurrencyPipe } from '@angular/common';
import { DateHelper } from '@src/app/shared/dateHelper';
import { CreditorsListService } from '@src/app/modules/txn/creditors-list/creditors-list.service';
import { FormNavLinkComponent } from '@src/app/shared/form/form-nav-button/form-nav-link.component';
import { PreferredSupplierPageNavRoute } from '@src/app/routes/preferred-supplier-page-nav';
import { CreditorsListPageNavRoute } from '@src/app/routes/creditors-list-page';

@Component({
    selector: 'app-creditors-list',
    imports: [FormPageComponent, CurrencyPipe],
    templateUrl: './creditors-list.component.html',
    styleUrl: './creditors-list.component.scss'
})
export class CreditorsListComponent {

    creditorsListSvc = inject(CreditorsListService);

    config = new FormConfig({
        navRoute: CreditorsListPageNavRoute,
        docPath: 'omc-books/purchase-accounting/creditors-list',
        title: $localize`Creditors List`,
        help: $localize`Whatever`,
        fieldSet: new FieldSet({
            fields: [
                FieldMaker.id(),
                FieldMaker.rev(),
                FormNavLinkComponent.makeDetail('Supplier', 'supplierName', 'supplierId', PreferredSupplierPageNavRoute),
                FormNumberComponent.makeCurrency('Total Purchases', 'totalPurchases').blankZero().override({ cellOpts: { style: 'text-align: left' } }),
                FormNumberComponent.makeCurrency('Total Payments', 'totalPayments').blankZero().override({ cellOpts: { style: 'text-align: left' } }),
                FormNumberComponent.makeCurrency('Balance', 'balance').blankZero().override({ cellOpts: { style: 'text-align: left' } }),

                FormDateComponent.make('asAtDate', 'asAtDate', { visible: Field.noShow })

            ],
            formLayout: LAYOUT_OPTIONS.singleCol,
        }),
        service: this.creditorsListSvc,
        mode: 'list',
        beforeList: this.beforeList.bind(this)
    });
    totalCreditors = 0;

    beforeList(items: {balance:number}[]) {
        this.totalCreditors = 0;
        items.forEach(u => this.totalCreditors += +u.balance);
        return items;
    }

    dayBefore(from: string) {
        return DateHelper.adjustDate(from, -1);
    }
}
